import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Container, Row, Col } from 'react-bootstrap';
import { selectTopMarketsWithOutcomes, daysLeft, marketDisplayName, eventDisplayName } from '../utils';
import OutrightOddButton from './OutrightOddButton';
import { OUTRIGHT_ACCENT, OUTRIGHT_ACCENT_RGB } from '../theme';

function TournamentCard({ event }) {
  const { t } = useTranslation('translations', { useSuspense: false });
  const navigate = useNavigate();

  if (!event?.se) return null;
  const se = event.se;
  const eventId = se.id;
  const displayName = eventDisplayName(event, t);
  const top = selectTopMarketsWithOutcomes(event, Infinity, 2);
  const dl = daysLeft(se.schedule_StartTime);
  const dlIsClose = dl != null && dl >= 0 && dl < 30;
  const dlLabel =
    dl == null
      ? ''
      : dl < 0
        ? t('outrights.inProgress')
        : t('outrights.daysLeft', { count: dl });

  const goToMarket = (marketStringId) =>
    navigate(
      `/outrights/${encodeURIComponent(eventId)}?market=${encodeURIComponent(marketStringId || 'all')}`
    );

  if (top.length === 0) return null;

  return (
    <>
      {top.map(({ market, outcomes, totalOutcomes }) => (
        <div
          key={market.stringId || market.id}
          className="matchCard bg-will-no-live mb-2"
          style={{ flexWrap: 'nowrap', display: 'block', cursor: 'pointer' }}
          onClick={() => goToMarket(market.stringId)}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              goToMarket(market.stringId);
            }
          }}>
          <div
            className="px-2 py-1 d-flex align-items-center gap-2"
            style={{
              background: `linear-gradient(135deg, rgba(${OUTRIGHT_ACCENT_RGB}, 0.18), transparent)`,
              borderBottom: '1px solid rgba(255,255,255,0.12)'
            }}>
            <span
              style={{
                fontSize: '0.65rem',
                opacity: 0.7,
                color: 'var(--bs-body-color)',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                lineHeight: 1.2
              }}>
              {displayName}
            </span>
            <span className="flex-grow-1" />
            <span
              className="fw-bold"
              style={{
                fontSize: '0.6rem',
                letterSpacing: '0.06em',
                color: dlIsClose ? OUTRIGHT_ACCENT : 'var(--bs-body-color)',
                opacity: dlIsClose ? 1 : 0.6,
                whiteSpace: 'nowrap'
              }}>
              {dlLabel}
            </span>
          </div>

          <div className="px-2 py-2">
            <div className="d-flex align-items-center justify-content-between gap-2 mb-3">
              <div
                className="bet_name text-start"
                style={{
                  fontSize: '0.85rem',
                  fontWeight: 700,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  minWidth: 0
                }}>
                {marketDisplayName(market, t)}
              </div>
              {totalOutcomes > outcomes.length && (
                <div
                  className="text-end"
                  style={{
                    fontSize: '0.7rem',
                    fontWeight: 700,
                    color: OUTRIGHT_ACCENT,
                    opacity: 0.95,
                    whiteSpace: 'nowrap',
                    flexShrink: 0
                  }}>
                  {t('outrights.moreOutcomes', { count: totalOutcomes })}
                </div>
              )}
            </div>
            <Row className="betname_bets_wrapper">
              <Container>
                <Row className="bets gy-2 gx-1">
                  {outcomes.map((outcome) => (
                    <Col
                      xs={6}
                      key={outcome.id}
                      className="betItem m-0 text-color-white d-flex flex-column align-items-center">
                      <div
                        className="text-center"
                        style={{
                          fontSize: '0.85rem',
                          fontWeight: 600,
                          opacity: 0.95,
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                          width: '100%',
                          marginBottom: 4
                        }}>
                        {outcome.name}
                      </div>
                      <div
                        style={{
                          width: '60%',
                          minWidth: 48,
                          fontSize: '0.7rem'
                        }}>
                        <OutrightOddButton
                          event={event}
                          market={market}
                          outcome={outcome}
                          betBox="bg-button-will-no-live"
                        />
                      </div>
                    </Col>
                  ))}
                </Row>
              </Container>
            </Row>
          </div>
        </div>
      ))}
    </>
  );
}

export default TournamentCard;
